/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type PlatformCustomerPaginatedProperty =
  typeof PlatformCustomerPaginatedProperty[keyof typeof PlatformCustomerPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformCustomerPaginatedProperty = {
  SID: 'SID',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  PLATFORM: 'PLATFORM',
  CREATED_AT: 'CREATED_AT',
  RISK_LEVEL: 'RISK_LEVEL',
  NEXT_CHECK_DATE: 'NEXT_CHECK_DATE',
  PRODUCT_ACCOUNT_BALANCE: 'PRODUCT_ACCOUNT_BALANCE',
  PENDING_AMOUNT: 'PENDING_AMOUNT',
} as const;
